import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { DISABLED_FONT_COLOR,BASE_TEXT_PX,CURSOR } from '../../../../styles/fonts/MCFontConstants';
import {isIpad, isMobileDevice} from 'src/utils/util.js';

export const useStyles = makeStyles((theme) => ({
    '@global': {
        '.MuiAutocomplete-option[data-focus="true"]': {
            background: 'none',
        },
        '.MuiAutocomplete-inputRoot': {
            flexWrap: 'nowrap !important',
        },
    },
    dynamicHeight: {
        maxHeight: ({ dropdownHeight }) =>
            dropdownHeight != undefined ? dropdownHeight : 'unset',
    },
    listRoot: {
        overflowY: 'scroll !important',
        // overflowX: 'hidden !important',
        '&::-webkit-scrollbar': {
            width: 7,
            display: 'block !important',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#00000029',
            borderRadius: '25px',
        },
    },
    options: {
        '&.MuiAutocomplete-option': {
            padding: ({ quickOrderPadding }) =>
                quickOrderPadding ? quickOrderPadding: '0',
            
        },
        '&.MuiAutocomplete-option:hover': {
            backgroundColor: ({ hoverBgColor }) =>
                hoverBgColor ? hoverBgColor : '#CFE8FE',
        },
        '&.MuiAutocomplete-option:active': {
            backgroundColor: 'unset !important',
        },
        '&[aria-selected="true"]': {
            backgroundColor: '#CFE8FE',
        },
    },
    popper: {
        '&.MuiAutocomplete-popper': {
            zIndex: ({ zIndex }) => (zIndex ? zIndex : 11000), 
           
        },
        '&.MuiAutocomplete-popper .MuiAutocomplete-paper': {
            [theme.breakpoints.up(768)]: {
                marginLeft: ({ isSearchDropdown }) =>
                    isSearchDropdown && 0,
            },
            padding: ({ isSearchDropdown }) => isSearchDropdown && '0 0 0 0'  ,
            marginTop: ({ isSearchDropdown }) => isSearchDropdown && '0px' ,
        },
        '&.MuiAutocomplete-popper .MuiAutocomplete-paper .MuiAutocomplete-noOptions':
            {
                padding: ({ optionPadding }) =>
                    optionPadding ? optionPadding : '12px 12px', 
            },
        '&.MuiAutocomplete-popper .MuiAutocomplete-paper .MuiAutocomplete-listbox': {
            padding: ({ isSearchDropdown }) => isSearchDropdown && '0 0',
        },
    },
    customTextField: {
        '& input': { 
            fontSize: ({ fontSize }) => (fontSize ? fontSize : BASE_TEXT_PX),
            fontFamily: 'AvenirNextWorld Regular',
            color: ({ inputColor }) => (inputColor),
            [theme.breakpoints.down(576)]: {
                paddingLeft: ({ mbPaddingLeft, value }) =>
                    value ? '10px' : mbPaddingLeft,
            },
            width:({ showSearchIcon }) => (showSearchIcon ? '80% !important' : '100%'),
            padding:({ showSearchIcon, isProductSearch, isQuickOrder }) => (
                isQuickOrder ? '13px 8px 10px 8px !important' :
                showSearchIcon && !isProductSearch? '10px 0 !important' :
                showSearchIcon && isProductSearch? '10px 8px !important' : '10px 10px !important'),
            cursor: ({ readOnly }) => (readOnly ? 'not-allowed' : 'text'),
            pointerEvents: ({ readOnly }) => (readOnly ? 'none' : 'auto'),   
        },    
        '& input:disabled': { 
                color: DISABLED_FONT_COLOR ,
            },
        '& input::placeholder': {
            fontSize: ({ fontSizePlaceholder }) =>
                fontSizePlaceholder ? fontSizePlaceholder : '16px',
            color: '#8f8f8f',
            opacity: 0.6,
            fontFamily: 'AvenirNextWorld Regular',
        },
        '&.MuiOutlinedInput-root': { 
            [theme.breakpoints.down(576)]: {
                borderRadius: ({ mbBorderRadius }) =>
                    mbBorderRadius ? mbBorderRadius : '',
            },
        },  
        '&.MuiAutocomplete-root':{
        border: ({ border }) => (border ? border:'' ),
        },
        '&.MuiAutocomplete-inputRoot': {
            flexWrap:({ showSearchIcon }) =>
                    showSearchIcon && 'none !important' ,
        },
        '&.MuiInput-underline:before, &.MuiInput-underline:after': {
            borderBottom: 'none !important',
        },
        '& .MuiInput-underline:before, & .MuiInput-underline:after': {
            borderBottom: 'none !important',
        },
        
        '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
            {
                border: ({ border }) => (border ? border : '2px solid #EBEDED'),
            },
    },
    paper: {
        '&.MuiAutocomplete-paper': {
            padding: '6px 0 0 0',
            // margin for mobile devices
            '@media (max-width: 450px)': {
                marginLeft: ({ marginLeftOption }) =>
                    marginLeftOption && marginLeftOption, // override for small screens
            },

            marginTop: '-10px',
        },
        '&.MuiPaper-elevation1': {
            boxShadow: '0px 7px 6px #00000029',
        },
    },
    detailsPaper: {
        '&.MuiAutocomplete-paper': {
            margin: 0,
            marginLeft: ({ marginLeft }) => (marginLeft ? marginLeft : 'unset'),
        },
    }, 
    popupIndicator: {
        marginRight: '4px !important', 
        marginLeft: '8px !important',
        '&.MuiAutocomplete-popupIndicatorOpen': { 
            marginRight:   '4px !important',
            marginLeft: '8px !important',
        }
    },
    startAdornment: {
        '&.MuiInputAdornment-positionStart':
        { 
        marginLeft:  ({ isAddItemSearchItem, isProductSearch }) => 
            (isAddItemSearchItem ? '6px !important' : 
                isProductSearch? '12px !important' : 
            '8px !important'), 
        marginRight:  ({isProductSearch,isAddItemSearchItem }) =>  
                isProductSearch? '2px !important':
                isAddItemSearchItem? '6px !important' :  ''
        },
    },
    endAdornment:{
        [theme.breakpoints.down(1025)]: {
            display:'flex !important'
        }
    },
    clearIndicator:{
        [theme.breakpoints.down(1025)]: {
            // display: 'block !important',
            visibility: 'visible !important',
        },  
        // display: isIpad() || isMobileDevice()? 'block !important' : undefined,
        visibility: isIpad() || isMobileDevice()? 'visible !important' : undefined,

        '@media (orientation: landscape) and (max-device-width: 1025px)': {
            // display: 'block !important',
            visibility: 'visible !important',
        }, 
         // General iPad target (covers most iPad models)
        '@media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape)': {
            // display: 'block !important',
            visibility: 'visible !important',
        },
        marginRight:  ({isAddItemSearchItem,isProductSearch }) =>  
                isAddItemSearchItem? '20px !important' : isProductSearch? '10px !important' : '',
        },  
}));

export const Icon = styled.img.attrs((props) => ({
    src: props.src,
    onClick: props.onClick,
}))`
    height: ${({ height }) => (height ? height : '15px')};
    opacity: ${({ opacity }) => (opacity ? opacity : '1')};
    cursor: ${({ cursor }) => CURSOR};
    margin-left: ${({ isAddItemSearchItem,showSearchIcon }) => 
        ((isAddItemSearchItem && showSearchIcon) && '8px')};
    margin-right: ${({ isAddItemSearchItem,showSearchIcon }) => 
        ((isAddItemSearchItem && showSearchIcon) && '-10px')};
`;

export const InputContainer = ({ backgroundDisabled, backgroundInactive, changeBackgroundDisabled }) => ({
    background: backgroundDisabled
        ? '#F1F1F1'
        : backgroundInactive
        ? backgroundInactive
        : '#ffffff 0% 0% no-repeat padding-box',
    backgroundColor: changeBackgroundDisabled ? '#F5F5F5' : '#ffffff',
    height: '40px',
    width: '100%',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box',
});

export const AutocompleteDiv = styled.div`
    position: relative;
    width: ${({ width }) =>
        width ? width : ''}; 
`;

export const DefaultChipDiv = styled.div`
    display: flex,
    alignItems: center,
    top: 50%,
    left: ${ ({ isMobile, inputValue}) =>
        isMobile &&
        inputValue
            ?.length +
            3 >
            31
            ? 31
            : !isMobile &&
                inputValue
                    ?.length +
                    3 >
                    37
            ? 37
            : inputValue
                    ?.length +
                    3 || 0
    }ch,
    // transform:
    //     'translateY(-50%)',
    zIndex: 1,
    paddingRight: 40px,
    overflow: hidden,
`;

export const InputFieldDiv = styled.div`
    position: relative
`;

export const DefaultChipSpan = styled.span`
    whiteSpace: nowrap,
    overflow: hidden,
    textOverflow: ellipsis
`;